import { GiftPassBundleApiError } from '../../../api/gift-pass-bundles';

import { serverErrorsToForm, type BundleFormErrors } from './bundle-form';

export function saveErrorToForm(error: unknown): BundleFormErrors {
  if (!(error instanceof GiftPassBundleApiError)) {
    return { form: 'The bundle couldn’t be saved. Check your connection and try again.' };
  }
  switch (error.status) {
    case 400:
    case 409: {
      const errors = serverErrorsToForm(error.fieldErrors);
      return Object.keys(errors).length > 0 ? errors : { form: error.message };
    }
    case 403:
      return { form: 'You don’t have permission to change bundles.' };
    case 404:
      return { form: 'This bundle no longer exists.' };
    default:
      return { form: 'The bundle couldn’t be saved. Try again in a moment.' };
  }
}
